import React from 'react';
import PropTypes from 'prop-types';
import Button from 'shared-components/Button/Button';

import env from 'utils/env';
import { trackAcquisitionStarted } from 'utils/segment';
import { CADENCE_TYPE } from 'utils/subscriptions';

import NotifyMeButton from 'Scenes/Products/NotifyMeButton/NotifyMeButton';

const CTA = {
  add: 'Add to Cart',
  join: 'Join Now',
  adding: 'Adding to Cart...',
};

export const ProductDetailPageCTA = ({
  id,
  sku,
  soldOut,
  salePrice,
  productName,
  isSubscriptionAvailable,
  isParisHiltonKit,
  isUpdatingCart,
  acquisitionType,
  addToPublicCart,
}) => {
  const handleClickAddToCart = () => {
    const redirectUrl = `https://${env.hostname}/checkout?sku=${sku}`;
    const cadenceType = isSubscriptionAvailable
      ? CADENCE_TYPE.NINETY_DAYS
      : null;
    addToPublicCart(
      id,
      'PDP',
      cadenceType,
      sku,
      productName,
      salePrice,
      redirectUrl
    );
  };

  const handleClickSoldOut = () => {
    trackAcquisitionStarted({
      cta: CTA.join,
      sku,
      productName,
      salePrice,
      acquisitionType,
    }).finally(() => {
      window.location.href = `https://${env.hostname}/get-the-box`;
    });
  };

  const renderButton = () => {
    if (isUpdatingCart) {
      return (
        <Button onClick={() => {}} dataTestId="updating-cart-button">
          {CTA.adding}
        </Button>
      );
    }
    if (soldOut) {
      if (isParisHiltonKit) {
        return <NotifyMeButton />;
      }
      return (
        <Button onClick={handleClickSoldOut} dataTestId="sold-out-button">
          {CTA.join}
        </Button>
      );
    }
    return (
      <Button onClick={handleClickAddToCart} dataTestId="add-to-cart-button">
        {CTA.add}
      </Button>
    );
  };

  return renderButton();
};

ProductDetailPageCTA.propTypes = {
  id: PropTypes.number.isRequired,
  sku: PropTypes.string.isRequired,
  soldOut: PropTypes.bool.isRequired,
  salePrice: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  isSubscriptionAvailable: PropTypes.bool.isRequired,
  isParisHiltonKit: PropTypes.bool.isRequired,
  isUpdatingCart: PropTypes.bool.isRequired,
  acquisitionType: PropTypes.string.isRequired,
  addToPublicCart: PropTypes.func.isRequired,
};

export default ProductDetailPageCTA;
